import $ from "jquery";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import { addLeadingZero } from './utils';
import Rellax from 'rellax';
import tilt from './tilt';

const MOBILE_CAROUSEL_BREAKPOINT = 1000;

let $desktopCarousel;
let $mobileCarousel;

let $carouselPrevCounter;
let $carouselNextCounter;

let carouselType;

const initTilt = () => {
  const tilt = $('.review').tilt({ glare: true, maxTilt: 15, disableAxis: 'x', maxGlare: .5});
}

const initRocketParallax = () => {
  $('.review-rocket__inner').addClass('complete');
  var rellax = new Rellax('.review-rocket__inner');
}


const carouselSettings = {
  loop: false,
  nav: true,
  dots: true,
  margin: 50,
  animateOut: 'fadeOutLeft',
  animateIn: 'fadeInLeft',
  mouseDrag: false,
  touchDrag: true,
  navContainer: '#reviews-carousel-nav',
  dotsContainer: '#reviews-carousel-dots',
  navText: ['', ''],
  navElement: 'div',
  autoplay: false,
  items: 1,
  autoHeight:true
};

const resizeHandler = () => {
  const width = window.innerWidth;

  if (width < MOBILE_CAROUSEL_BREAKPOINT && carouselType !== 'mobile') {
    initMobileCarousel();
    carouselType = 'mobile';
  } else if (width >= MOBILE_CAROUSEL_BREAKPOINT && carouselType != 'desktop') {
    initCarousel();
    carouselType = 'desktop';
  }
}

const handleChangeSlide = e => {
  const index = e.item.index + 1;
  let count = e.item.count;
  const width = window.innerWidth;

  let prevIndex, nextIndex;

  if (width < MOBILE_CAROUSEL_BREAKPOINT) {
    prevIndex = (index - 1) > 1 ? index - 1 : 1;
    nextIndex = (index + 1) < count ? index + 1 : count;
  } else {
    count *= 2;
    prevIndex = (index * 2 - 1) > 1 ? (index * 2 - 1) : 1;
    nextIndex = (index * 2 + 1) < count ? index * 2 + 1 : count;
  }

  $carouselPrevCounter.text(addLeadingZero(prevIndex));
  $carouselNextCounter.text(addLeadingZero(nextIndex));
}

const initMobileCarousel = () => {

  $desktopCarousel.trigger('destroy.owl.carousel');

  $mobileCarousel.on('initialized.owl.carousel', handleChangeSlide);

  const carousel = $mobileCarousel.owlCarousel(carouselSettings);

  carousel.on('changed.owl.carousel', handleChangeSlide);

  return carousel;
}

const initCarousel = () => {

  $mobileCarousel.trigger('destroy.owl.carousel');

  $desktopCarousel.on('initialized.owl.carousel', handleChangeSlide);

  const carousel = $desktopCarousel.owlCarousel(carouselSettings);

  carousel.on('changed.owl.carousel', handleChangeSlide);

  return carousel;
};


export const initReviews = () => {
  $desktopCarousel = $('.reviews-carousel--desktop');
  $mobileCarousel = $('.reviews-carousel--mobile');
  $carouselPrevCounter = $('.reviews').find('.nav-prev-counter');
  $carouselNextCounter = $('.reviews').find('.nav-next-counter');

  $carouselPrevCounter.on('click', (e) => {
    $(e.target).siblings('#reviews-carousel-nav').children('.owl-prev').click();
  });

  $carouselNextCounter.on('click', (e) => {
    $(e.target).siblings('#reviews-carousel-nav').children('.owl-next').click();
  });

  resizeHandler();
  $(window).on('resize', resizeHandler);

  // document.addEventListener('aos:in:rocket', (e) => {
  //   console.log(e);
  //   setTimeout(initRocketParallax, 2500);
  // });

  initRocketParallax();
  initTilt();
};
